import constant from '../../constant';
import {statTicket} from "../../../utils";
import { isTBS, isAndroid } from '../../../utils/UA';

import {get} from "lodash";
import {reportUg} from "../../../utils/stat";

const setRecommendPopStatus = (params = {}) => {
  let { show = false } = params;
  delete show.isInit;
  const ipwindowOneStart = get(window, '_configs.experient.ipwindowOneStart', '');
  const ipwindowTwoStart = get(window, '_configs.experient.ipwindowTwoStart', '');
  const ipwindowOneMid = get(window, '_configs.experient.ipwindowOneMid', '');
  const ipwindowTwoMid = get(window, '_configs.experient.ipwindowTwoMid', '');
  const profileIdMatchList = get(window, '_configs.profileIdMatchList', []);
  const isOneStart = profileIdMatchList.indexOf(Number(ipwindowOneStart)) > -1;
  const isTwoStart = profileIdMatchList.indexOf(Number(ipwindowTwoStart)) > -1;
  const isOneMid = profileIdMatchList.indexOf(Number(ipwindowOneMid)) > -1;
  const isTwoMid = profileIdMatchList.indexOf(Number(ipwindowTwoMid)) > -1;
  console.log('设置弹窗参数', params, profileIdMatchList, isOneStart, isTwoStart, isOneMid, isTwoMid);
  console.log('isNeedShow', (params.from === 'recommend' && (isOneStart || isTwoStart)), (!params.from && (isOneMid || isTwoMid)), !(isTBS(window.navigator.userAgent) && isAndroid(window.navigator.userAgent)))
  const isNeedShow = (params.from === 'recommend' && (isOneStart || isTwoStart)) || (!params.from && (isOneMid || isTwoMid));
  if (show && isNeedShow) {
  //if (show && (isOneStart || isTwoStart || isOneMid || isTwoMid || !isTBS()) ) {

    params.isSingle = isOneStart || isOneMid;
    if (!(isTBS(window.navigator.userAgent) && isAndroid(window.navigator.userAgent))) {
      params.isSingle = false;
    }
    params.isInit = true;

    // 上报曝光
    if (params.isSingle) {
      reportUg(2, 'ipwindow_one');
      statTicket({user_action: 'ipwindow_one_expose'});
    }else {
      reportUg(2, 'ipwindow_two');
      statTicket({user_action: 'ipwindow_two_expose'});
    }
  }else {
    params.show = false;
  }
  return {
    type: constant.RECOMMEND_POP.SET_STATUS,
    ...params
  }
}

export default {
  setRecommendPopStatus,
}